export default "/_next/static/images/hero-5ad1e3e2e2ea04d633d00e33cdfcdd56.png";